import type { Routes } from '@angular/router';

// NGXS states are registered as component-level providers on each lazy-loaded
// route component (not here) so their dependencies (Dexie, ECharts, mathjs, ...)
// stay out of the eagerly-loaded main bundle.
export const routes: Routes = [
  {
    path: 'forbidden',
    loadChildren: async () => import('@schaeffler/empty-states').then((m) => m.ForbiddenModule),
    data: {
      headingText: 'Forbidden',
      messageText: 'Sorry, you dont have access to this page',
      label: 'Forbidden',
    },
  },
  {
    path: '',
    pathMatch: 'full',
    data: {
      defaultRoute: true,
      label: 'Home',
    },
    loadChildren: async () => (await import('./pages/landing-page/landing-page.routes')).default,
  },
  {
    path: 'databrowser',
    data: {
      label: 'Databrowser',
    },
    loadChildren: async () => (await import('./databrowser/databrowser.routes')).default,
  },
  {
    path: 'databrowser/:id',
    data: {
      defaultRoute: true,
      label: 'Databrowser',
    },
    loadChildren: async () => (await import('./databrowser/databrowser.routes')).default,
  },
  {
    path: 'telemetry',
    data: {
      label: 'Telemetry',
    },
    loadChildren: async () => (await import('./pages/telemetry-page/telemetry-page.routes')).default,
  },
  {
    path: 'iot-status',
    data: {
      label: 'IoT Devices',
    },
    loadChildren: async () => (await import('./pages/iot-status-page/iot-status-page.routes')).default,
  },
  {
    path: 'twin/:id',
    data: {
      label: 'Twin Details ',
    },
    loadChildren: async () => (await import('./pages/twin-page/twin-page.routes')).default,
  },
  {
    path: 'anomalies',
    data: {
      label: 'Anomalies',
    },
    loadChildren: async () => (await import('./pages/anomalies-page/anomalies-page.routes')).default,
  },
  {
    path: 'settings',
    data: {
      label: 'Settings',
    },
    loadChildren: async () => (await import('./pages/settings-page/settings-page.routes')).default,
  },
];
